export const timeInSeconds = () => Math.floor(Date.now() / 1000);
